import type { GiftPassDetail } from '../../api/gift-passes';

import { formatPassDate, formatPassDateTime } from './gift-passes-model';
import { GiftPassBookingValue } from './GiftPassBookingValue';

function voidReason(pass: GiftPassDetail): string | null {
  return pass.events.find((e) => e.type === 'VOIDED')?.note ?? null;
}

export function GiftPassOutcomeFields({ pass }: { pass: GiftPassDetail }) {
  const { redemption } = pass;
  const voided = pass.void;
  if (!redemption && !voided) return null;
  const reason = voidReason(pass);
  return (
    <dl className="gp-field-list gp-section">
      {redemption && (
        <>
          <dt>Redeemed on</dt>
          <dd>
            <GiftPassBookingValue booking={redemption.booking} />
          </dd>
          <dt>Redeemed</dt>
          <dd>{formatPassDateTime(redemption.redeemedAt)}</dd>
        </>
      )}
      {voided && (
        <>
          <dt>Voided</dt>
          <dd>
            {voided.voidedByName && <strong>{voided.voidedByName} · </strong>}
            {formatPassDate(voided.voidedAt)}
          </dd>
        </>
      )}
      {reason && (
        <>
          <dt>Reason</dt>
          <dd>{reason}</dd>
        </>
      )}
    </dl>
  );
}
